<template>
  <div>
    <v-stepper-step :complete="step > stepConfig" step="!">
      Informações adicionais
      <template v-if="step > stepConfig">
        <v-chip small class="mt-1 mb-1"
          >Contato: {{ atestadoEnviar.ddd
          }}{{ atestadoEnviar.telefone }}</v-chip
        >
        <v-chip small
          >Justificativa: {{ atestadoEnviar.justificativa }}</v-chip
        ></template
      >
    </v-stepper-step>
    <v-stepper-content :step="stepConfig">
      <v-card flat>
        <v-card-text class="pt-0 pb-0">
          <h4>Contato</h4>
          <v-row>
            <v-col xl="3" lg="3" md="3" sm="12" cols="12">
              <v-text-field
                type="text"
                label="DDD"
                v-mask="'##'"
                v-model="atestadoEnviar.ddd"
              ></v-text-field>
            </v-col>
            <v-col xl="9" lg="9" md="9" sm="12" cols="12">
              <v-text-field
                type="text"
                label="Número"
                v-mask="'#########'"
                v-model="atestadoEnviar.telefone"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pt-0 mt-0">
              <v-textarea
                label="Justificativa/Observação"
                rows="3"
                v-model="atestadoEnviar.justificativa"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <botoes-stepper />
        </v-card-actions>
      </v-card>
    </v-stepper-content>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BotoesStepper from "./BotoesStepper.vue";
export default {
  components: { BotoesStepper },
  computed: mapState("atestado", ["atestadoEnviar", "step"]),
  data: () => ({
    stepConfig: 70,
  }),
};
</script>

<style>
</style>